import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom'
import SvgSprite from "../utility/SvgSpriteLoader"
import { connect } from 'react-redux'
import * as actions from '../actions/auth/auth'

import NewLanding from './landing/NewLanding'
import Faq from './faq/Faq'
import NetworkFeedLayout from './networkFeed/NetworkFeedLayout'
import Contact from './contact/Contact'
import Notifications from './notifications/Notifications'
import PostDetails from './networkFeed/PostDetails.js';
import Event from './events/event'
import AddEvent from './events/addevent'
import Pricing from './pricing/pricing'
import ScrollToTop from './ScrollToTop';
import PaymentFailure from './pricing/PaymentFailure';

// Import css
import '../assets/scss/style.scss';

// Import new pages
// import NewHomeView from './newhome/home';
// import AboutUsView from './aboutus/aboutus';
import SignUpView from './authentication/signup/SignUpView';
import ListingNamesView from './pricing/listing-names/listing-names';
import ThankyouView from './pricing/thank-you/thank-you';
import SetNewPassword from './authentication/setnew-password/SetNewPassword';
import EditProfileView from './profile/Profile';
import InviteView from './common/invite/invite';
import selectMail from "./select-mail/select-mail";
import SelectMailMessage from "./select-mail/select-mail-message";

//Svg Sprite
import svgFile from "../assets/images/svg/svg-sprite.svg";
// import svgsFile from "../assets/images/svg/svgs-sprite.svg";

import Industry from './industry/Industry';
import Vendors from './vendors/Vendors';
import Customers from './customers/Customers';
import connections from './connections/connections';
import ProductpageWip from './productpage_wip/productpage_wip';
import CompanyPage from './company_page/company_page';
import FeedViewDev from './feed-new/feed-new';
import FeedView from './feed-new-bk/feed-new';

import MessageLayout from './message/MessageLayout';
import eventsList from './events/eventsList';
import VerifyOtp from './authentication/verify-otp/VerifyOtp';

import ArticlesEditor from './networkFeed/articles/ArticlesEditor';
import ArticlesView from './networkFeed/articlesview';
import RequestQuote from './request-quote';
import LoginWithOtp from './authentication/LoginWithOtp';
import LoginWithOtpNewUser from './authentication/LoginWithOtpNewUser';
import ProfileCompletion from './networkFeed/Profile-Completion';
import NewsList from './newslist/index.js';
import RedirectFailure from './authentication/LoginWithOtp/RedirectFailure.js';
import MediaQuery from 'react-responsive';
import { LinkAuthenticate } from './authentication/LoginWithOtp/LinkAuthenticate.js';

// new ui pages
import HomePage from '../new-ui/components/homepage/index.js';
import AboutUs from '../new-ui/components/aboutus/index.js';
import EcosystemView from '../new-ui/components/ecosystem/index.js';
import BlogsView from '../new-ui/components/blogs/index.js';
import EventsListView from '../new-ui/components/events/index.js';
import ValueChainView from '../new-ui/components/valuechain/index.js';
import MappesNetworkView from '../new-ui/components/mappes-network/index.js';
import CareersView from '../new-ui/components/careers/index.js';
import FaqsView from '../new-ui/components/faqs/index.js';
import ContactUsView from '../new-ui/components/contactus/index.js';
import SolarVew from '../new-ui/components/ecosystem/solar/index.js';
import AdditiveManufacturingVew from '../new-ui/components/ecosystem/additive-manufacturing/index.js';
import CarbonFibersVew from '../new-ui/components/ecosystem/carbon-fiber/index.js';
import OpticalFibersVew from '../new-ui/components/ecosystem/optical-fiber/index.js';
import UVEBcurvingVew from '../new-ui/components/ecosystem/uv-eb-curving/index.js';
import GreenHydrogenView from '../new-ui/components/ecosystem/green-hydrogen/index.js';
import SemiconductorView from '../new-ui/components/ecosystem/semiconductor/index.js';
import LithiumIonView from '../new-ui/components/ecosystem/lithium-ion/index.js';

class App extends Component {

  componentDidMount() {
    this.props.fetchUser();
  }

  componentDidUpdate() {
    if (this.props.auth.firstName && this.props.auth.lastName) {
      // User details needed only till user logs-in. Not needed after that
      // Used first name and last name here is there is no difference between new user with pending details (fn/ln) and old logged in user in terms of auth props
      localStorage.removeItem('userId')
      localStorage.removeItem('newUser')
      localStorage.removeItem('email')
      sessionStorage.removeItem('otp')
    }
  }

  render() {
    if (this.props.auth === null) { return null };
    return (
      <BrowserRouter onUpdate={() => window.scrollTo(100, 100)}>
        <div className="main-wrapper">
          <SvgSprite url={svgFile} />
          {/* <SvgSprite url={svgsFile} /> */}
          <ScrollToTop>
            {/* <Route exact path="/" component={NewHomeView} /> */}
            <Route exact path="/NewLanding" component={NewLanding} />
            {/* TODO */}
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/profile" component={EditProfileView} />
            <Route exact path="/faq" component={Faq} />
            {/* <Route exact path="/onBoarding" component={onBoarding} />
            {/* //TODO: is post id needed? */}
          
            <Route exact path="/notifications" component={Notifications} />
            {/* <Route exact path="/signup/verificationMessage" component={EmailVerificationMessage} /> */}
            {/* TODO: add SEO */}
            <Route path="/networkFeed/:feedType/:entityId?/:postId?" component={NetworkFeedLayout} />
            <Route exact path="/feed/post/:postId" component={PostDetails} />
            <Route exact path="/events/:name?/:eventId" component={Event} />
            <Route exact path="/addevent" component={AddEvent} />
            <Route exact path="/edit-event/:id" component={AddEvent} />
            <Route exact path="/pricing" component={Pricing} />
            <Route exact path="/payment/success" component={ListingNamesView} />
            <Route exact path="/payment/failure" component={PaymentFailure} />
            <Route path="/industry/:id" component={Industry} />
            {/* <Route exact path="/aboutus" component={AboutUsView} /> */}
            <Route exact path="/signup" component={SignUpView} />
            <Route exact path="/thankyou" component={ThankyouView} />
            <Route exact path="/resetpassword" component={SetNewPassword} />
            <Route exact path="/connections" component={connections} />
            <Route exact path="/invite" component={InviteView} />
            <Route exact path="/vendors" component={Vendors} />
            <Route exact path="/customers" component={Customers} />
            <Route exact path="/select-mail" component={selectMail} />
            <Route exact path="/select-mail-message" component={SelectMailMessage} />
            <Route exact path="/product/:name?/:id/:view?" component={ProductpageWip} />
            <Route exact path="/company/:name?/:id/:view?" component={CompanyPage} />
            <Route exact path="/feeds-dev" component={FeedViewDev} />
            <Route exact path="/feeds" component={FeedView} />
            <Route exact path="/message" component={MessageLayout} />
            <Route exact path="/event-list" component={eventsList} />
            <Route exact path="/verify-otp" component={VerifyOtp} />
            <Route exact path="/add-article/:feedType?/:entityId?" component={ArticlesEditor} />
            <Route exact path="/edit-article/:id/:feedType?/:entityId?" component={ArticlesEditor} />
            <Route exact path="/article/:name?/:postId" component={ArticlesView} />
            <Route exact path="/request-quote/:type?/:id?" component={RequestQuote} />
            <Route exact path="/otp-login" component={LoginWithOtp} />
            <Route exact path="/otp-login/:failed" component={RedirectFailure} />
            <Route exact path="/otp-new-login" component={LoginWithOtpNewUser} />
            <Route exact path="/link-authenticate/:userId" component={LinkAuthenticate} />
            <Route exact path="/profile-completion" component={ProfileCompletion} />
            <Route exact path="/news" component={NewsList} />

            {/* new ui pages */}
            <Route exact path="/buyers" component={HomePage} />
            <Route exact path="/aboutus" component={AboutUs} />
            <Route exact path="/articles" component={BlogsView} />
            <Route exact path="/event" component={EventsListView} />
            <Route exact path="/value-chain" component={ValueChainView} />
            <Route exact path="/mappes-network" component={MappesNetworkView} />
            <Route exact path="/careers" component={CareersView} />
            <Route exact path="/faqs" component={FaqsView} />
            <Route exact path="/contact-us" component={ContactUsView} />

            <Route exact path="/ecosystem" component={EcosystemView} />
            <Route exact path="/ecosystem/solar" component={SolarVew} />
            <Route exact path="/ecosystem/carbon-fiber" component={CarbonFibersVew} />
            <Route exact path="/ecosystem/additive-manufacturing" component={AdditiveManufacturingVew} />
            <Route exact path="/ecosystem/optical-fiber" component={OpticalFibersVew} />
            <Route exact path="/ecosystem/lithium-ion" component={LithiumIonView} />
            <Route exact path="/ecosystem/semiconductors" component={SemiconductorView} />
            <Route exact path="/ecosystem/green-hydrogen" component={GreenHydrogenView} />
            <Route exact path="/ecosystem/uv-eb-curing" component={UVEBcurvingVew} />

            {/* Reminder : Homepage shifting at the bottom so that route should be last to avoid conflicts */}
            <Route exact path="/" component={HomePage} />
          </ScrollToTop>
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return { auth };
}

export default connect(mapStateToProps, actions)(App);
